import { scrollToSection } from "../../function";

export default function Hero() {
    return (
        <section id="home" className="hero bg_img" data-background="assets/images/bg/hero.jpg">
        <div className="container">
          <div style={{marginLeft:'0px' , marginRight:'0px'}} className="row container">
          <div className="col-xl-2 col-lg-12">
            </div>
            <div className="col-xl-8 col-lg-8">
              <div style={{textAlign:'center', alignItems:'center', justifyContent:'center', marginTop:'-130px'}} className="hero__content">
                <h2 className="hero__title">
                  {/* <span className="text-white font-weight-normal">
                    Invest for Future in Stable Platform
                  </span>{" "} */}
                  <b className="base--color f-size-19">We have 3 different reward systems for our community.</b>
                </h2>
                <p className="text-white f-size-16 mt-3">
                  Simple referral programme- 
                  Login using your wallet address and create your affiliate link . Each referral who buys our tokens you get 5% of the total tokens bought by your referrals at the time we start the claiming process of the tokenz.
                </p>
                <a style={{cursor:'pointer'}} onClick={ async () => { await scrollToSection('tasks')}} className="cmn-btn text-uppercase font-weight-600 mt-4">
                  attempt Task
                </a>
              </div>
            </div>
            <div className="col-xl-2 col-lg-12">
            </div>
          </div>
        </div>
      </section>
    );
}